import api from "@rentiohq/shared-frontend/dist/utils/api/api.utils";
// The user-scoped preference calls live in the shared-frontend preferences module
// (`reduxV2/preferences/preference.api`), which the saga uses directly.
// Writes onto the active (office) account.
export var setPreferencesForBroker = function (data) {
    return api.patch("/brokers/me/preferences", { data: data, isV2: true });
};
export var getIndexLastModified = function (url) { return api.head(url); };
